import React from 'react';
import {Label, designSystemToken} from '@lightricks/react-design-system';
import styles from './BriefField.module.scss';

interface BriefFieldProps {
  label: string;
  children: React.ReactNode;
}

function BriefField({label, children}: BriefFieldProps) {
  return (
    <div className={styles.container}>
      <Label size="sm" color={designSystemToken('semantic.fg.secondary')}>
        {label}
      </Label>
      {children}
    </div>
  );
}

export default BriefField;
